
const UNANSWERED_SENTINEL = '__unanswered__';

const isUnansweredSentinel = (value) => value === UNANSWERED_SENTINEL;

const isAnsweredResponse = (response) => (
  response !== undefined
  && response !== null
  && response.value !== null
  && response.value !== undefined
  && !isUnansweredSentinel(response.value)
);

const withoutUnanswered = (responses) =>
  (responses || []).filter(isAnsweredResponse);

module.exports = {
  UNANSWERED_SENTINEL,
  isUnansweredSentinel,
  isAnsweredResponse,
  withoutUnanswered,
};